import jwtDecode, { type JwtPayload } from 'jwt-decode';

import {
  type Fleet,
  type Session,
  UserPermission,
  type UserRole,
  type UUID,
} from '@cobliteam/common-types';

import { CookieManager } from '@cobliteam/cookie-manager';

export interface CobliJwtPayload extends JwtPayload {
  sessionId: UUID;
  userId: UUID;
  fullName: string;
  role: UserRole;
  emailAddress: string;
  groupsRestriction: string[];
  fleets: Fleet[];
  fleetId: UUID;
}

const COBLER_TEMPORARY_TOKEN = 'cobler-temporary-token';

export class TemporaryTokenManager {
  public static getTemporaryToken = () =>
    CookieManager.getCookie(COBLER_TEMPORARY_TOKEN);

  public static deleteTemporaryToken = () => {
    document.cookie = `${encodeURIComponent(
      COBLER_TEMPORARY_TOKEN
    )}=; max-age=0; domain=cobli.co`;
  };

  public static buildSessionFromTemporaryToken(jwt: string): Session {
    const jwtPayload = jwtDecode<CobliJwtPayload>(jwt);

    const session: Session = {
      id: jwtPayload.sessionId,
      user: {
        id: jwtPayload.userId,
        name: jwtPayload.fullName,
        role: jwtPayload.role,
        email: jwtPayload.emailAddress,
        groupsRestriction: jwtPayload.groupsRestriction,
        grantedPermissions: Object.values(UserPermission),
      },
      fleet: {
        id: jwtPayload.fleetId,
        name: jwtPayload.fleets[0].name,
        active: jwtPayload.fleets[0].active,
      },
      authenticationToken: jwt,
    };

    return session;
  }
}
